import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { PROFILE_GA_CATEGORY } from '../../constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../EventTrackingConstants';
import { PICTURE_GALLERY_KEY } from './constants';

export const ActionTypes = {
    NEXT_PICTURE: `${PICTURE_GALLERY_KEY}/next_picture`,
    PREVIOUS_PICTURE: `${PICTURE_GALLERY_KEY}/previous_picture`,
    SELECT_PICTURE: `${PICTURE_GALLERY_KEY}/select_picture`,
    SHOW_PICTURE_GALLERY: `${PICTURE_GALLERY_KEY}/show_picture_gallery`,
    CLOSE_PICTURE_GALLERY: `${PICTURE_GALLERY_KEY}/close_picture_gallery`,
    PICTURE_GALLERY_SHOWN: `${PICTURE_GALLERY_KEY}/picture_gallery_shown`,
};

export const showGallery = ({
    pictures, action, Element, EventAction,
}) => ({
    type: ActionTypes.SHOW_PICTURE_GALLERY,
    payload: pictures,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action,
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE_NAME_CARD,
                Component: TARGETS.PROFILE_PROVIDER_PICTURE,
                Element,
                EventAction,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
            },
        },
    },
});

export const galleryShown = () => ({
    type: ActionTypes.PICTURE_GALLERY_SHOWN,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Show Picture Overlay',
            tags: [
                'Gallery',
            ],
            label: '',
        },
    },
});

export const closeGallery = ({ interaction }) => ({
    type: ActionTypes.CLOSE_PICTURE_GALLERY,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Close Picture Overlay',
            category: PROFILE_GA_CATEGORY,
            tags: [
                'Gallery',
            ],
            label: interaction,
            data: {
                Section: TARGETS.PICTURE_GALLERY,
                Component: TARGETS.PROFILE_PROVIDER_PICTURE,
                Element: TARGETS.PICTURE_GALLERY,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click close picture gallery',
            },
        },
    },
});

export const selectPicture = ({ picture, pictureUrl, interaction }) => ({
    type: ActionTypes.SELECT_PICTURE,
    payload: picture,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Select Picture',
            category: PROFILE_GA_CATEGORY,
            tags: [
                'Gallery',
            ],
            label: interaction,
            data: {
                Section: TARGETS.PICTURE_GALLERY,
                Component: TARGETS.PROFILE_PROVIDER_PICTURE,
                Element: TARGETS.PICTURE_GALLERY,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'select picture',
                EventDetails: {
                    PictureNumber: picture,
                    PictureUrl: pictureUrl,
                },
            },
        },
    },
});

export const nextPicture = ({ picture, pictureUrl, interaction }) => ({
    type: ActionTypes.NEXT_PICTURE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Next Picture',
            category: PROFILE_GA_CATEGORY,
            tags: [
                'Gallery',
            ],
            label: interaction,
            data: {
                Section: TARGETS.PICTURE_GALLERY,
                Component: TARGETS.PROFILE_PROVIDER_PICTURE,
                Element: TARGETS.PICTURE_GALLERY,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click next picture',
                EventDetails: {
                    PictureNumber: picture,
                    PictureUrl: pictureUrl,
                },
            },
        },
    },
});

export const previousPicture = ({ picture, pictureUrl, interaction }) => ({
    type: ActionTypes.PREVIOUS_PICTURE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Previous Picture',
            category: PROFILE_GA_CATEGORY,
            tags: [
                'Gallery',
            ],
            label: interaction,
            data: {
                Section: TARGETS.PICTURE_GALLERY,
                Component: TARGETS.PROFILE_PROVIDER_PICTURE,
                Element: TARGETS.PICTURE_GALLERY,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click previous picture',
                EventDetails: {
                    PictureNumber: picture,
                    PictureUrl: pictureUrl,
                },
            },
        },
    },
});
